export const COMMANDS = {
  default: 'output',
  output: 'output',
  update: 'update',
};



// WEBPACK FOOTER //
// ./src/const.js